module.exports = __webpack_public_path__ + "img/live.b32e01d6.png";